module.exports = __webpack_public_path__ + "static/img/401.064a635.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/401.png
// module id = 520
// module chunks = 3